import React from 'react';

const CloseIcon = ({ color, className }) => (
  <svg viewBox="0 0 37 32.7" fill={`${color}`} className={className}>
    <path d="M4.3 14.6h26.5v3.5H4.3z" transform="rotate(45.001 17.602 16.35)" />
    <path
      d="M4.3 14.6h26.5v3.5H4.3z"
      transform="rotate(-45.001 17.602 16.351)"
    />
  </svg>
);

export default CloseIcon;



// WEBPACK FOOTER //
// ./src/sources/closeIcon.js